import { OptionItem } from 'app/pages/prd/dep/data/savings'
import { Dep0410CtlrOut } from '../../api/dep/dep0410'

export interface joinProductIf {
    /**
     * 상품 카테고리코드
     * 입출금 : '103'
        적금∙청약 : '101'
        예금∙중금채 : '102'
        체크카드 : '302'
        신용카드 : '301'
        대출 : '600'
        보험 : '400'
        퇴직연금(IRP) : 'A00'
        ISA : '800'
        펀드 : '500'
     */
    catlDcd: string //상품 카테고리코드
    limitMoney: number //한도금액
    newMoney: number //신규금액
    periodYear: string //기간년수  ex) 1,2,3
    newPassword1: string //신규계좌 비밀번호
    newPassword2: string //신규계좌 비밀번호 확인
    orssUnqPdcd: string //상품코드
    nfchPrcfGrpCd: string //상품(목돈만들기,대출,입출식자유) 그룹코드
    /** 예적금청약중금채일때 신규계좌비밀번호 타입 > 출금계좌와동일 0, 새로운비밀번호 1 */
    newPasswordType: string
    /** 계약서류 제공방법 5:카카오톡 4:SMS 3:Email */
    contractSelect: string

    allPdcd: string //풀 상품코드 //comboFlageInfo.SEL_ALL_PDCD
    pdlnCd: string //상품라인코드
    pdgrCd: string //상품그룹코드
    pdtmCd: string //상품템플릿코드
    pdcd: string //상품코드
    ccalCd: string // 신용카드 제휴코드
    pdm: string //상품명 -IBK 평생한가족 통장
    nfchOfrPdm: string // 상품명 : 추가(전문에서 받은값) //comboFlageInfo.SEL_NFCH_OFR_PDM
    rsrgLmtAmt: number //적립한도금액
    newAmt: number //신규금액
    arrTrm: string //계약기간(년)
    arrTrm2: string //계약기간(월)
    arrTrmType: string //계약기간_구분자 1:년 2:개월
    acntPwd: string //계좌비밀번호
    lftmAcn: string //평생계좌번호
    newAcn: string //신규계좌번호
    icn: string //내부계약번호
    rcndEmn: string //권유자직원번호
    rcndEmnNM: string //권유자직원명
    bncd: string //은행코드
    iobAcn: string //당타행계좌번호
    bprIdxNo: string //BPR인덱스번호
    pinPwd: string //PIN비밀번호
    mngmBrcd: string //권유자부점코드 / 관리지점코드
    defaultBrcd: string //권유자부점코드 / 관리지점코드
    copnNo: string //쿠폰 번호
    copnMrknSrn: string //쿠폰 인증 번호
    atmBkdrRgsnYn: string //스마트폰(ATM통장출금등록여부)
    nomdDwotRgsnYn: string //무매체(무매체출금거래등록여부)
    pwd02: string //무매체비밀번호(무매체거래용비밀번호)
    depExpiNtchDcd: string //수신만기통보구분코드 (0:미신청 / 1:신청(휴대폰))
    atmtExpiTrmtAplcYn: string //만기자동해지 신청여부
    atexDcd: string //자동연장구분코드(빈값:직접해지 1:만기자동연장 2:만기자동해지)
    expiMnrcAcn: string //만기자동해지 입금 계좌번호
    attrYn: string //자동이체 여부
    traCylDcd: string //자동이체 매월, 매주, 매일, 은행영업일 체크
    tranDsgtDd: string //이체지정일 DD
    tranOpngYmd: string //자동이체 등록년월일
    attrAcn: string //자동이체 출금계좌번호
    tranPwd: string //자동이체 계좌 비밀번호
    drtrfAmt: number //자동이체 금액
    rgrnDcd: string //우대금리 여부 4개 YYYY, YNNY NNNN 등
    rcmrNo: string //친구추천번호 ( 전행고객번호 )
    smsRecommand: string
    slnmBnkbNm: string //IBK D-day적금 셀프네이밍통장명
    baseAmt: string //IBK D-day적금 목표금액
    frstJoinRfsnYn: string //IBK D-day적금 우대금리가능여부
	copnIssued: string // 우대금리쿠폰발행일련번호 (IBK D-day적금 등)
    //이어가기에서 받은데이터
    lmtAcntYn: string //한도계좌여부
    //비즈허브 쿠폰분류코드관련 정보 추가
    copnPtrnLrcd: string //쿠폰유형대분류코드
    copnPtrnMdvcd: string //쿠폰유형중분류코드
    copnPtrnSmdcd: string //쿠폰유형소분류코드
    copnMrknAlcmCd: string //쿠폰마케팅제휴사코드
    copnPtrnSrn: string //쿠폰유형일련번호
	copnPrnlRt: number // 쿠폰우대율
    /**
     * 계약기간구분코드(1:년, 2:개월, 4:일)
     */
    cnteDcd: string

    // 비대면채널 전문변경관련 추가 필드
    pdfIntcd: string // 상품내부코드
    whbnVcd: string // 전행서비스코드
    nfchPrcfGrpCdNm: string //비대면채널상품분류그룹코드명
    nfchPdfMxmnAgrmInr: string // 비대면채널상품최대약정금리
    nfchPrsaYn: string // 비대면채널상품판매여부
    jnngChnlInfoCon1: string // 가입채널정보내용
    jnngChnlInfoCon2: string // 가입채널정보내용
    jnngTrm: string // 가입기간
    loinDsncNm: string // 대출금리구분명
    pdfPtrnNm: string // 상품유형명
    cardBrcoDsncNm1: string // 카드브랜드사구분명1
    cardBrcoDsncNm: string // 카드브랜드사구분명2
    pdfImgUrlAdr: string //상품이미지URL주소
    jnngLonkUrlAdr: string // 가입링크URL주소
    pdfPrmrCon: string // 상품주요내용
    pdfRmrkCon: string // 상품비고내용
    // saleNbi1: string // 1개월 판매건수
    // saleNbi3: string // 3개월 판매건수
    // saleNbi6: string // 6개월 판매건수
    // saleNbi12: string // 12개월 판매건수
    krnBrm: string // 한글부점명
    cosnYn: string // 보험동의 여부(IBK W소확행 중금채적립식 input)
    vrtlAcn: string // 가상계좌
    bncdNm: string // 은행명
    nfchprcfgrpcd: string //그룹코드(각상품별설정)  //comboFlageInfo.SEL_NFCH_PRCF_GRP_CD
    expiDate: string //적금만기일
    alplDcd: string
    reJoinYn: string

    autoTransType?: OptionItem //자동이체 신청타입
    autoTransDay?: OptionItem //자동이체 월 > 일
    autoTransDayOfWeek?: OptionItem //자동이체 매주 > 요일
    expireMethod?: OptionItem //만기자동해지방법
    /**금융소비자상세구분코드 */
    fnlcDtlDcd: string
    comboFlage: boolean //

    rqstCd: string //상품요청코드 있으면 만기예상금액버튼 show
    joinAmtMethod: 'OUT' | 'AUTO' | 'VIRTUAL' | string //가입금액입금방법
    outAcn: string //출금계좌번호
    atmtRdpsCosnDcd: string //자동재예치동의구분코드(01:동의_SMS거절,02:거절, 03:연락불가, 04:동의_SMS통지)

    sido: string // 입주희망지역 시/도
    gungu: string // 입주희망지역 군/구
    mdlDcd: string // 희망주택형 셋팅
    sqmDcd: string // 주택면적(전용면적)
    mihYm: string // 희망입주시기
    joinPeriodTabIndex: string // 가입기간/만기일 선택값
    nextPage: string
    v3LoadCheck: boolean

    /** 나라사랑 현장 즉발 여부*/
    isNarasarangInstantJoin: boolean
    /** 나라사랑 사후 연동 여부*/
    isNarasarangPostLinkage: boolean
    /** 사전신청 여부 */
    isPreSign: boolean
    /** 사전신청 정보 */
    presignInfo?: Dep0410CtlrOut
    /** 로그인연계ID - 네이버 ID */
    lgnLnkId: string
}

export const initialState: joinProductIf = {
    catlDcd: '', //상품 카테고리코드
    limitMoney: 0, //한도금액
    newMoney: 0, //신규금액
    periodYear: '', //기간년수  ex) 1,2,3
    newPassword1: '', //신규계좌 비밀번호
    newPassword2: '', //신규계좌 비밀번호 확인
    orssUnqPdcd: '', //상품코드
    nfchPrcfGrpCd: '', //상품(목돈만들기,대출,입출식자유) 그룹코드
    /** 예적금청약중금채일때 신규계좌비밀번호 타입 > 출금계좌와동일 0, 새로운비밀번호 1 */
    newPasswordType: '',
    contractSelect: '',

    allPdcd: '', //풀 상품코드
    pdlnCd: '', //상품라인코드
    pdgrCd: '', //상품그룹코드
    pdtmCd: '', //상품템플릿코드
    pdcd: '', //상품코드
    ccalCd: '', //신용카드제휴코드
    pdm: '', //상품명 -IBK 평생한가족 통장
    nfchOfrPdm: '', // 상품명 : 추가(전문에서 받은값)
    rsrgLmtAmt: 0, //적립한도금액
    newAmt: 0, //신규금액
    arrTrm: '', //계약기간(년)
    arrTrm2: '', //계약기간(월)
    arrTrmType: '', //계약기간_구분자 1:년 2:개월
    acntPwd: '', //계좌비밀번호
    lftmAcn: '', //평생계좌번호
    newAcn: '', //신규계좌번호
    icn: '', //내부계약번호
    rcndEmn: '', //권유자직원번호
    rcndEmnNM: '', //권유자직원명
    bncd: '', //은행코드
    iobAcn: '', //당타행계좌번호
    bprIdxNo: '', //BPR인덱스번호
    pinPwd: '', //PIN비밀번호
    mngmBrcd: '', //권유자부점코드 / 관리지점코드
    defaultBrcd: '', //권유자부점코드 / 관리지점코드
    copnNo: '', //쿠폰 번호
    copnMrknSrn: '', //쿠폰 인증 번호
    atmBkdrRgsnYn: '', //스마트폰(ATM통장출금등록여부)
    nomdDwotRgsnYn: '', //무매체(무매체출금거래등록여부)
    pwd02: '', //무매체비밀번호(무매체거래용비밀번호)
    depExpiNtchDcd: '', //수신만기통보구분코드 (0:미신청 / 1:신청(휴대폰))
    atmtExpiTrmtAplcYn: '', //만기자동해지 신청여부
    expiMnrcAcn: '', //만기자동해지 입금 계좌번호
    atexDcd: '',
    attrYn: '', //자동이체 여부
    traCylDcd: '', //자동이체 매월, 매주, 매일, 은행영업일 체크
    tranDsgtDd: '', //이체지정일 DD
    tranOpngYmd: '', //자동이체 등록년월일
    attrAcn: '', //자동이체 출금계좌번호
    tranPwd: '', //자동이체 계좌 비밀번호
    drtrfAmt: 0, //자동이체 금액
    rgrnDcd: '', //우대금리 여부 4개 YYYY, YNNY NNNN 등
    rcmrNo: '', //친구추천번호 ( 전행고객번호 )
    smsRecommand: '',
    slnmBnkbNm: '', //IBK D-day적금 셀프네이밍통장명
    baseAmt: '', //IBK D-day적금 목표금액
    frstJoinRfsnYn: '', //IBK D-day적금 우대금리가능여부
	copnIssued: '', // 우대금리 쿠폰발행일련번호 (IBK D-day적금 등)
    //이어가기에서 받은데이터
    lmtAcntYn: '', //한도계좌여부
    //비즈허브 쿠폰분류코드관련 정보 추가
    copnPtrnLrcd: '', //쿠폰유형대분류코드
    copnPtrnMdvcd: '', //쿠폰유형중분류코드
    copnPtrnSmdcd: '', //쿠폰유형소분류코드
    copnMrknAlcmCd: '', //쿠폰마케팅제휴사코드
    copnPtrnSrn: '', //쿠폰유형일련번호
	copnPrnlRt: 0, // 쿠폰우대율
    cnteDcd: '', //계약기간구분코드(1:년, 2:개월, 4:일)

    // 비대면채널 전문변경관련 추가 필드
    pdfIntcd: '', // 상품내부코드
    whbnVcd: '', // 전행서비스코드
    nfchPrcfGrpCdNm: '', //비대면채널상품분류그룹코드명
    nfchPdfMxmnAgrmInr: '', // 비대면채널상품최대약정금리
    nfchPrsaYn: '', // 비대면채널상품판매여부
    jnngChnlInfoCon1: '', // 가입채널정보내용
    jnngChnlInfoCon2: '', // 가입채널정보내용
    jnngTrm: '', // 가입기간
    loinDsncNm: '', // 대출금리구분명
    pdfPtrnNm: '', // 상품유형명
    cardBrcoDsncNm1: '', // 카드브랜드사구분명1
    cardBrcoDsncNm: '', // 카드브랜드사구분명2
    pdfImgUrlAdr: '', //상품이미지URL주소
    jnngLonkUrlAdr: '', // 가입링크URL주소
    pdfPrmrCon: '', // 상품주요내용
    pdfRmrkCon: '', // 상품비고내용
    // saleNbi1: '', // 1개월 판매건수
    // saleNbi3: '', // 3개월 판매건수
    // saleNbi6: '', // 6개월 판매건수
    // saleNbi12: '', // 12개월 판매건수
    krnBrm: '', // 한글부점명
    cosnYn: '', // 보험동의 여부(IBK W소확행 중금채적립식 input)
    vrtlAcn: '', // 가상계좌번호
    bncdNm: '', // 은행명
    nfchprcfgrpcd: '', //그룹코드(각상품별설정)
    expiDate: '', //적금만기일
    alplDcd: '03', //적금만기일
    reJoinYn: 'N',

    autoTransType: undefined, //자동이체 신청타입
    autoTransDay: undefined, //자동이체 월 > 일
    autoTransDayOfWeek: undefined, //자동이체 매주 > 요일
    expireMethod: undefined, //만기자동해지방법
    fnlcDtlDcd: '', //금융소비자상세구분코드
    comboFlage: false, //
    rqstCd: '', //상품요청코드 있으면 만기예상금액버튼 show
    joinAmtMethod: '',
    outAcn: '',
    atmtRdpsCosnDcd: '',
    sido: '', // 입주희망지역 시/도
    gungu: '', // 입주희망지역 군/구
    mdlDcd: '', // 희망주택형 셋팅
    sqmDcd: '', // 주택면적(전용면적)
    mihYm: '', // 희망입주시기
    joinPeriodTabIndex: '',
    nextPage: '',
    v3LoadCheck: false,
    /** 나라사랑 현장 즉발 여부*/
    isNarasarangInstantJoin: false,
    /** 나라사랑 사후 연동 여부*/
    isNarasarangPostLinkage: false,
    /** 사전신청 여부 */
    isPreSign: false,
    presignInfo: undefined,
    /** 로그인연계ID - 네이버 ID */
    lgnLnkId: '',
}

export const initJoinProductIf: joinProductIf = {
    catlDcd: '', //상품 카테고리코드
    limitMoney: 0, //한도금액
    newMoney: 0, //신규금액
    periodYear: '', //기간년수  ex) 1,2,3
    newPassword1: '', //신규계좌 비밀번호
    newPassword2: '', //신규계좌 비밀번호 확인
    orssUnqPdcd: '', //상품코드
    nfchPrcfGrpCd: '', //상품(목돈만들기,대출,입출식자유) 그룹코드
    /** 예적금청약중금채일때 신규계좌비밀번호 타입 > 출금계좌와동일 0, 새로운비밀번호 1 */
    newPasswordType: '',
    contractSelect: '',

    allPdcd: '', //풀 상품코드
    pdlnCd: '', //상품라인코드
    pdgrCd: '', //상품그룹코드
    pdtmCd: '', //상품템플릿코드
    pdcd: '', //상품코드
    ccalCd: '', //신용카드 제휴코드
    pdm: '', //상품명 -IBK 평생한가족 통장
    nfchOfrPdm: '', // 상품명 : 추가(전문에서 받은값)
    rsrgLmtAmt: 0, //적립한도금액
    newAmt: 0, //신규금액
    arrTrm: '', //계약기간(년)
    arrTrm2: '', //계약기간(월)
    arrTrmType: '', //계약기간_구분자 1:년 2:개월
    acntPwd: '', //계좌비밀번호
    lftmAcn: '', //평생계좌번호
    newAcn: '', //신규계좌번호
    icn: '', //내부계약번호
    rcndEmn: '', //권유자직원번호
    rcndEmnNM: '', //권유자직원명
    bncd: '', //은행코드
    iobAcn: '', //당타행계좌번호
    bprIdxNo: '', //BPR인덱스번호
    pinPwd: '', //PIN비밀번호
    mngmBrcd: '', //권유자부점코드 / 관리지점코드
    defaultBrcd: '', //권유자부점코드 / 관리지점코드
    copnNo: '', //쿠폰 번호
    copnMrknSrn: '', //쿠폰 인증 번호
    atmBkdrRgsnYn: '', //스마트폰(ATM통장출금등록여부)
    nomdDwotRgsnYn: '', //무매체(무매체출금거래등록여부)
    pwd02: '', //무매체비밀번호(무매체거래용비밀번호)
    depExpiNtchDcd: '', //수신만기통보구분코드 (0:미신청 / 1:신청(휴대폰))
    atmtExpiTrmtAplcYn: '', //만기자동해지 신청여부
    atexDcd: '',
    expiMnrcAcn: '', //만기자동해지 입금 계좌번호
    attrYn: '', //자동이체 여부
    traCylDcd: '', //자동이체 매월, 매주, 매일, 은행영업일 체크
    tranDsgtDd: '', //이체지정일 DD
    tranOpngYmd: '', //자동이체 등록년월일
    attrAcn: '', //자동이체 출금계좌번호
    tranPwd: '', //자동이체 계좌 비밀번호
    drtrfAmt: 0, //자동이체 금액
    rgrnDcd: '', //우대금리 여부 4개 YYYY, YNNY NNNN 등
    rcmrNo: '', //친구추천번호 ( 전행고객번호 )
    smsRecommand: '',
    slnmBnkbNm: '', //IBK D-day적금 셀프네이밍통장명
    baseAmt: '', //IBK D-day적금 목표금액
    frstJoinRfsnYn: '', //IBK D-day적금 우대금리가능여부
	copnIssued: '', // 우대금리쿠폰발행일련번호 (IBK D-day적금 등)
	
    //이어가기에서 받은데이터
    lmtAcntYn: '', //한도계좌여부
    //비즈허브 쿠폰분류코드관련 정보 추가
    copnPtrnLrcd: '', //쿠폰유형대분류코드
    copnPtrnMdvcd: '', //쿠폰유형중분류코드
    copnPtrnSmdcd: '', //쿠폰유형소분류코드
    copnMrknAlcmCd: '', //쿠폰마케팅제휴사코드
    copnPtrnSrn: '', //쿠폰유형일련번호
	copnPrnlRt: 0,
    cnteDcd: '', //계약기간구분코드(1:년, 2:개월, 4:일)

    // 비대면채널 전문변경관련 추가 필드
    pdfIntcd: '', // 상품내부코드
    whbnVcd: '', // 전행서비스코드
    nfchPrcfGrpCdNm: '', //비대면채널상품분류그룹코드명
    nfchPdfMxmnAgrmInr: '', // 비대면채널상품최대약정금리
    nfchPrsaYn: '', // 비대면채널상품판매여부
    jnngChnlInfoCon1: '', // 가입채널정보내용
    jnngChnlInfoCon2: '', // 가입채널정보내용
    jnngTrm: '', // 가입기간
    loinDsncNm: '', // 대출금리구분명
    pdfPtrnNm: '', // 상품유형명
    cardBrcoDsncNm1: '', // 카드브랜드사구분명1
    cardBrcoDsncNm: '', // 카드브랜드사구분명2 (cardBrcoDsncNm2 -> cardBrcoDsncNm)
    pdfImgUrlAdr: '', //상품이미지URL주소
    jnngLonkUrlAdr: '', // 가입링크URL주소
    pdfPrmrCon: '', // 상품주요내용
    pdfRmrkCon: '', // 상품비고내용
    // saleNbi1: '', // 1개월 판매건수
    // saleNbi3: '', // 3개월 판매건수
    // saleNbi6: '', // 6개월 판매건수
    // saleNbi12: '', // 12개월 판매건수
    krnBrm: '', // 한글부점명
    cosnYn: '', // 보험동의 여부(IBK W소확행 중금채적립식 input)
    vrtlAcn: '', // 가상계좌번호
    bncdNm: '', // 은행명
    nfchprcfgrpcd: '', //그룹코드(각상품별설정)
    expiDate: '', //적금만기일
    alplDcd: '03', //적금만기일
    reJoinYn: 'N',

    autoTransType: undefined, //자동이체 신청타입
    autoTransDay: undefined, //자동이체 월 > 일
    autoTransDayOfWeek: undefined, //자동이체 매주 > 요일
    expireMethod: undefined, //만기자동해지방법
    fnlcDtlDcd: '', //금융소비자상세구분코드
    comboFlage: false, //
    rqstCd: '', //상품요청코드 있으면 만기예상금액버튼 show
    joinAmtMethod: '',
    outAcn: '',
    atmtRdpsCosnDcd: '',
    sido: '', // 입주희망지역 시/도
    gungu: '', // 입주희망지역 군/구
    mdlDcd: '', // 희망주택형 셋팅
    sqmDcd: '', // 주택면적(전용면적)
    mihYm: '', // 희망입주시기
    joinPeriodTabIndex: '',
    nextPage: '',
    v3LoadCheck: false,
    /** 나라사랑 현장 즉발 여부*/
    isNarasarangInstantJoin: false,
    /** 나라사랑 사후 연동 여부*/
    isNarasarangPostLinkage: false,
    /** 사전신청 여부 */
    isPreSign: false,
    presignInfo: undefined,
    /** 로그인연계ID - 네이버 ID */
    lgnLnkId: '',
}
